/**
 * Shared registry of `{ path, page }` route entries, mutated in place by
 * `router.js` and read by `matching.js` and `urlFor.js`.
 */
const listeners = []

export default listeners
